import { configureStore } from "@reduxjs/toolkit";
import expenseReducer from "@/store/redux/organization/expenseSlice";
import authReducer from "@/store/redux/authSlice";
import appReducer from "@/store/redux/appSlice";
import categoryReducer from "@/store/redux/organization/categorySlice";
import branchReducer from "@/store/redux/organization/branchSlice";
import userDetailReducer from "@/store/redux/userDetailsSlice";
import memberReducer from "@/store/redux/organization/memberSlice";
import filterReducer from "@/store/redux/filterSlice";
import itemReducer from "@/store/redux/organization/itemSlice";
import graphReducer from "@/store/redux/organization/graphExpenses";

export const store = configureStore({
  reducer: {
    expense: expenseReducer,
    auth: authReducer,
    app: appReducer,
    category: categoryReducer,
    branch: branchReducer,
    userDetail: userDetailReducer,
    member: memberReducer,
    filter: filterReducer,
    item: itemReducer,
    graph: graphReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
